import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonItem, IonLabel } from "@ionic/react";
import { ReportRecord } from "../../services/client-records/clients-provider";

export const ReportSummaryCard: React.FC<{
  report: ReportRecord;
  clientName?: string;
  showClientName?: boolean;
}> = ({report, clientName, showClientName = true}) => {
  let status = "not started";
  if (report.accountsData) {
    status = "holdings table extracted";
  }
  if (report.morningstarData) {
    status = "analysis complete; insights ready"
  }
  const displayName = clientName ?? report.clientName ?? 'Unknown Client';
  const cardTitle = showClientName ? displayName : (report?.createdAt?.toLocaleString() || "Report in Progress");
  return <IonCard style={{ marginBottom: "1em" }} routerLink={`/clients/${report.clientId}/reports/${report.id}`}>
    <IonCardHeader>
      <IonCardTitle>{cardTitle}</IonCardTitle>
    </IonCardHeader>
    <IonCardContent>
      <IonItem>
        <IonLabel>
          <h2>Report Date</h2>
          <p>{"Started: " + (report?.createdAt?.toLocaleString() || "Report in Progress")}</p>
        </IonLabel>
      </IonItem>
      <IonItem>
        <IonLabel>
          <h2>Status</h2>
          <p>{status}</p>
        </IonLabel>
      </IonItem>
    </IonCardContent>
  </IonCard>
}